<template>
  <the-dialog-box
    ref="dialogBox"
    :submit=" (isProducedState || isShippedState || isReceivedState || isShippedToSiteState || isRepackageState) ? submitQr : submit"
    :secondary-submit="undoState"
    :submit-btn-text="submitBtnText()"
    :submit-btn-disabled="item.wip_panel_packing_slip_items.length < 1"
    :is-submit-btn="!isRecevedToSiteState"
    :is-secondary-btn="isReceivedState || isShippedState || isShippedToSiteState || isRecevedToSiteState"
    :secondary-btn-text="undoBtnText()"
    :full-screen="true"
    :persistent="true"
  >
    <!-- :secondary-btn-text="isReceivedState ? 'Undo Receive' : isShippedState ? 'Undo Ship' : ''" -->
    <template slot="header">
      <span>{{ headlineText() }} Packing Slip {{ item.slip_number ? `#${item.slip_number}` : '' }}</span>
    </template>
    <template slot="body">
      <v-row>
        <v-col
          v-if="item && item.status"
          class="text-center"
        >
          <h3 class="h3">
            Status
          </h3>
          <v-chip
            medium
            :color="item && item.status ? item.status.color : 'black'"
            text-color="white"
            class="mt-1"
          >
            {{ item && item.status ? item.status.name : '' }}
          </v-chip>
        </v-col>
        <v-col
          v-if="item && item.created_at"
          class="text-center"
        >
          <h3 class="h3">
            Created At
          </h3>
          <span class="mt-1 font-weight-bold">{{ item ? item.created_at : '' }}</span>
        </v-col>
        <v-col
          v-if="item && item.created_by_name"
          class="text-center"
        >
          <h3 class="h3">
            Created By
          </h3>
          <span class="mt-1 font-weight-bold">{{ item ? item.created_by_name : '' }}</span>
        </v-col>
        <v-col
          v-if="item && item.shipped_at"
          class="text-center"
        >
          <h3 class="h3">
            Shipped Date
          </h3>
          <span class="mt-1 font-weight-bold">{{ item ? item.shipped_at : '' }}</span>
        </v-col>
        <v-col
          v-if="item && item.shipped_by_name"
          class="text-center"
        >
          <h3 class="h3">
            Shipped By
          </h3>
          <span class="mt-1 font-weight-bold">{{ item ? item.shipped_by_name : '' }}</span>
        </v-col>
        <v-col
          v-if="item && item.received_at"
          class="text-center"
        >
          <h3 class="h3">
            Received Date
          </h3>
          <span class="mt-1 font-weight-bold">{{ item ? item.received_at : '' }}</span>
        </v-col>
        <v-col
          v-if="item && item.received_by_name"
          class="text-center"
        >
          <h3 class="h3">
            Received By
          </h3>
          <span class="mt-1 font-weight-bold">{{ item ? item.received_by_name : '' }}</span>
        </v-col>
        <v-col
          v-if="item && item.received_at"
          class="text-center"
        >
          <h3 class="h3">
            Received Location
          </h3>
          <span class="mt-1 font-weight-bold">{{ item ? item.location_name : '' }}{{ item && item.shelf_name ? `; ${item.shelf_name}` : '' }}</span>
        </v-col>
      </v-row>
      <v-row
        v-if="isShippedState"
        align="center"
      >
        <v-col
          cols="3"
          class="mt-4 pb-0"
        >
          <v-autocomplete
            v-model="location"
            :items="locations"
            item-text="name"
            item-value="id"
            :rules="[(v) => !!v || 'Location is required']"
            required
          >
            <template slot="label">
              Location<RedAsterisk />
            </template>
          </v-autocomplete>
        </v-col>
        <v-col
          v-if="location === locationId14Precidio || location === locationId440Hanlan"
          cols="3"
          class="mt-4 pb-0"
        >
          <v-autocomplete
            v-model="shelf"
            label="Shelf"
            :items="shelves"
            item-text="name"
            item-value="id"
            clearable
            :rules="[(v) => !!v || 'Shelf is required']"
            no-data-text="Select a Location First"
          >
            <template slot="label">
              Shelf<RedAsterisk />
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>

      <v-row
        v-if="isReceivedState || isRepackageState"
        align="center"
      >
        <v-col
          cols="3"
          class="mt-4 pb-0"
        >
          <v-autocomplete
            v-model="project"
            :items="projects"
            item-text="name"
            item-value="id"
            :rules="[(v) => !!v || 'Project is required']"
            required
          >
            <template slot="label">
              Project<RedAsterisk />
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>
      <v-row
        v-else-if="!(isProducedState || isShippedState || isReceivedState || isShippedToSiteState || isRecevedToSiteState || isRepackageState) && item.status_id !== glassPoStatusIdReceived"
        align="center"
      >
        <v-col
          cols="3"
          class="mt-4 pb-0"
        >
          <v-text-field
            v-model="wipPanelQr"
            autofocus
            @keydown.enter.native.prevent
            @input="qrCodeValueChange"
          />
        </v-col>
        <v-col
          cols="auto"
          class="mt-4 pb-0"
        >
          <v-btn
            color="primary"
            outlined
            :disabled="!wipPanelQr"
            @click="addWipPanel"
            @keyup.enter="addWipPanel"
          >
            Add Panel
          </v-btn>
        </v-col>
        <v-spacer />
        <v-col
          class="mt-4 pb-0"
          cols="auto"
        >
          <span style="font-size: 60px; font-weight: bold; color: #000;">Total QTY: {{ item.wip_panel_packing_slip_items.length }}</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          class="pt-0"
        >
          <v-card
            elevation="0"
            outlined
          >
            <v-data-table
              :headers="headers"
              :items="item.wip_panel_packing_slip_items"
              hide-default-footer
              :items-per-page="-1"
              dense
            >
              <template #[`item.class`]="{ item }">
                <v-chip
                  small
                  :color="item && item.wip_panel && item.wip_panel.job && item.wip_panel.job.class ? item.wip_panel.job.class.color : 'black'"
                  text-color="white"
                >
                  {{ item && item.wip_panel && item.wip_panel.job && item.wip_panel.job.class ? item.wip_panel.job.class.name : '' }}
                </v-chip>
              </template>
              <!-- <template #[`item.item_index`]="{ item }">
                <span>
                  {{ item && item.wip_panel && item.wip_panel.item_index ? item.wip_panel.item_index : '' }}
                </span>
              </template> -->
              <!-- <template #[`item.batch_number`]="{ item }">
                <span
                  class="font-weight-bold"
                >
                  {{ item && item.wip_panel && item.wip_panel.batch ? item.wip_panel.batch.batch_number : '' }}
                </span>
              </template> -->
              <!-- <template #[`item.work_order`]="{ item }">
                {{ item && item.wip_panel && item.wip_panel.job ? item.wip_panel.job.work_order : '-' }}
              </template> -->
              <template #[`item.id`]="{ item }">
                {{ item && item.wip_panel ? item.wip_panel.id : '-' }}
              </template>
              <template #[`item.work_order`]="{ item }">
                {{ item && item.wip_panel && item.wip_panel.job ? item.wip_panel.job.code : '-' }}
              </template>
              <template #[`item.type`]="{ item }">
                {{ item && item.wip_panel && item.wip_panel.type ? item.wip_panel.type.code : '-' }}
              </template>
              <template #[`item.tag_number`]="{ item }">
                {{ item && item.wip_panel ? item.wip_panel.tag_number : '-' }}
              </template>
              <template #[`item.description`]="{ item }">
                {{ item && item.wip_panel && item.wip_panel.type ? item.wip_panel.type.description : '-' }}
              </template>
              <template #[`item.color`]="{ item }">
                {{ item && item.wip_panel && item.wip_panel.color ? item.wip_panel.color.code && item.wip_panel.color.name ? `${item.wip_panel.color.code} ${item.wip_panel.color.name}` : item.wip_panel.color.code : '-' }}
              </template>
              <template #[`item.width`]="{ item }">
                {{ item && item.wip_panel ? (uomSwitch ? convertToFraction(item.wip_panel.width) : item.wip_panel.width) : '-' }}
              </template>
              <template #[`item.height`]="{ item }">
                {{ item && item.wip_panel ? (uomSwitch ? convertToFraction(item.wip_panel.height) : item.wip_panel.height) : '-' }}
              </template>
              <template #[`item.sqft`]="{ item }">
                {{ item && item.wip_panel ? item.wip_panel.sqft : '-' }}
              </template>
              <template #[`item.produced_date`]="{ item }">
                {{ item && item.wip_panel && item.wip_panel.produced_date ? convertDateFormat(item.wip_panel.produced_date) : '-' }}
              </template>
              <template #[`item.status`]="{ item }">
                <v-chip
                  small
                  :color="item && item.wip_panel && item.wip_panel.status ? item.wip_panel.status.color : 'black'"
                  text-color="white"
                >
                  {{ item && item.wip_panel && item.wip_panel.status ? item.wip_panel.status.name : '' }}
                </v-chip>
              </template>
              <template #[`item.actions`]="{ item }">
                <v-btn
                  v-if="isRemoveBtn()"
                  class="ml-1 mt-1 mb-1"
                  color="error"
                  outlined
                  small
                  @click="removeWIPPanelItem(item)"
                >
                  REMOVE
                </v-btn>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-spacer />
        <v-col
          cols="auto"
          class="pb-0 pt-0"
        >
          <v-row align="center">
            <v-col class="pr-2 pt-6">
              <span :style="{color: isDarkMode ? '#ffffffb3' : '#00000099', fontSize: '16px !important'}">Decimal</span>
            </v-col>
            <v-col class="pl-0">
              <v-switch
                v-model="uomSwitch"
                hide-details
                class="mt-0 pt-3"
                label="Fraction"
              />
            </v-col>
          </v-row>
        </v-col>
        <v-col
          cols="auto"
          class="text-end pr-10"
        >
          <span :style="{ color: isDarkMode ? '' : '#000000', fontWeight: 'bold', fontSize: '18px' }">Total Panel Qty: {{ item.wip_panel_packing_slip_items.length }}</span>
        </v-col>
      </v-row>
      <confirm-form ref="confirmForm" />
    </template>
  </the-dialog-box>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  components: {
  },
  props: {

  },
  data: () => ({
    item: null,
    itemDto: {
      id: 0,
      wip_packing_slip_id: null,
      wip_panel_packing_slip_items: [],
      type_id: 1,
    },
    wipPanelQr: null,
    glassItems: [],
    location: null,
    locations: [],

    headers: [
      {   
        text: 'Class', value: 'class', align: 'center',
      },
      { text: 'ID', value: 'id', align: 'center' },
      { text: 'Tag#', value: 'tag_number' },
      { text: 'Work Order', value: 'work_order' },
      { text: 'Panel Code/Type', value: 'type' },
      { text: 'Description', value: 'description' },
      { text: 'Color', value: 'color' },
      { text: 'Width', value: 'width' },
      { text: 'Height', value: 'height' },
      { text: 'Sqft', value: 'sqft' },
      {
        text: 'Status', value: 'status', align: 'center',
      },
      { text: 'Produced At', value: 'produced_date' },
      {
        text: 'Actions', value: 'actions', align: 'end',
      },
    ],
    loading: false,
    uomSwitch: true,
    isProducedState: false,
    isShippedState: false,
    isReceivedState: false,
    isShippedToSiteState: false,
    isRecevedToSiteState: false,
    isRepackageState: false,
    glassPoStatusIdToBeIssued: 1,
    glassPoStatusIdProduced: 3,
    glassPoStatusIdShipped: 6,
    glassPoStatusIdReceived: 7,
    glassPoStatusIdShippedToSite: 12,
    glassPoStatusIdReceivedOnSite: 13,
    glassPoStatusIdIssued: 17,
    glassPoStatusIdRepackage: 18,
    timeoutId: null,
    typeIdpackSlip: 1,
    typeIdSingleGlass: 2,
    typeIdRearrange: 3,
    glassTypeIdSingle: 3,
    poNumbers: [],
    loadingPo: false,
    selectedPoNumber: null,
    projects: [],
    project: null,
    locationId440Hanlan: 1,
    locationId14Precidio: 3,
    shelf: null,
    shelves: [],
    customPanelWorkflow4800: false,
    customPanelWorkflow6000: false,
  }),
  computed: {
    ...mapState({
      user: (state) => state.user,
      isDarkMode: 'isDarkMode',
    }),
    ...mapGetters([
      'businessRulesGetBoolean',
    ]),
  },
  watch: {
    location() {
      this.getShelves();
    },
  },
  created() {
    this.item = { ...this.itemDto };
    this.init();
  },
  methods: {

    async init() {
      await this.getLocations();
      this.getProjects();
      const customPanelWorkflow4800 = '4800 Custom Panel Workflow';
      this.customPanelWorkflow4800 = this.businessRulesGetBoolean(customPanelWorkflow4800);
      const customPanelWorkflow6000 = '6000 Custom Panel Workflow';
      this.customPanelWorkflow6000 = this.businessRulesGetBoolean(customPanelWorkflow6000);
    },

    async open(id = null, formState = null, typeId = 1) {
        console.log('opening packing slip form');
        this.$bus.$emit('loading');
        if (id) {
            this.setFormState(id, formState);
            await this.get(id);
        } else {
            this.item = JSON.parse(JSON.stringify(this.itemDto));
            this.item.type_id = typeId;
        }
        await this.$refs.dialogBox.open(); // for some reason need to add await, otherwise user's location won't be set in v-autocomplete by default
        this.location = this.user.location_id;
        this.$bus.$emit('loading');
    },

    async get(id) {
      const submitModel = {
        filters: {
          id,
        },
      };
      const res = await this.$api.wipPanelPackingSlip.read(submitModel);
      const cancelCode = 3001;
      if (res === cancelCode) return;
      if (!res || res.length === 0) {
        this.$bus.$emit('showError', 'WIP Panel Packing Slip not found');
        return;
      }
      const firstIndex = 0;
      this.item = res.data[firstIndex];
    },

    async getLocations() {
      const res = await this.$api.location.get();

      if (!res) return;
      this.locations = res;
    },

    async getShelves() {
      if (!this.location) return;
      const readModel = {
        filters:
          {
            location_id: this.location,
          },
        search: 'GL -',
      };
      this.shelves = await this.$api.inventoryLocation.read(readModel);
    },

    async getProjects() {
      const submitModel = {
        filters: {
          is_all: 1,
        },
      };

      const res = await this.$api.project.read(submitModel);
      const cancelCode = 3001;
      if (res === cancelCode) {
        return;
      }
      if (!res || !res.data) {
        this.projects = [];
        return;
      }
      this.projects = res.data;
    },

    async submit() {
      this.$bus.$emit('loading');
      let res = false;

      if (this.item.id) {
        res = await this.$api.wipPanelPackingSlip.update(this.item);
      } else {
        res = await this.$api.wipPanelPackingSlip.store(this.item);
      }
      if (!res) {
        this.$bus.$emit('loading');
        this.$bus.$emit('showError');
        return false;
      }
      this.$bus.$emit('loading');
      this.$bus.$emit('showSuccess');
      this.$emit('success');
      return true;
    },

    async submitQr() {
      let title = '';
      if (this.isProducedState) {
        title = 'Are you sure that you want to ship this packing slip?';
      } else if (this.isShippedState) {
        title = 'Are you sure that you want to receive this packing slip?';
      } else if (this.isReceivedState || this.isRepackageState) {
        title = 'Are you sure that you want to ship this packing slip to site?';
      } else if (this.isShippedToSiteState) {
        title = 'Are you sure that you want to receive this packing slip on site?';
      }
      const confirm = await this.$refs.confirmForm.open({
        title,
      });
      if (!confirm) return false;
      this.$bus.$emit('loading');
      const statusId = this.getStatusId();
      const updateModel = {
        location_id: this.location,
        shelf_id: this.shelf,
        project_id: this.project,
        status_id: statusId,
        id: this.item.id,
      };
      const res = await this.$api.wipPanelPackingSlip.update(updateModel, 'status');
      if (!res) {
        this.$bus.$emit('loading');
        this.$bus.$emit('showError');
        return false;
      }
      this.$bus.$emit('loading');
      this.$bus.$emit('showSuccess');
      return true;
    },

    async undoState() {
      let title = '';
      if (this.isReceivedState) {
        title = 'Are you sure that you want to undo receive this packing slip?';
      } else if (this.isShippedState) {
        title = 'Are you sure that you want to undo ship this packing slip?';
      } else if (this.isShippedToSiteState) {
        title = 'Are you sure that you want to undo ship this packing slip to site?';
      } else if (this.isRecevedToSiteState) {
        title = 'Are you sure that you want to undo receive this packing slip on site?';
      }
      const confirm = await this.$refs.confirmForm.open({
        title,
      });
      if (!confirm) return false;
      this.$bus.$emit('loading');
      const statusId = this.getUndoStatusId();
      const updateModel = {
        status_id: statusId,
        id: this.item.id,
      };
      const res = await this.$api.wipPanelPackingSlip.update(updateModel, 'undo-status');
      if (!res) {
        this.$bus.$emit('loading');
        this.$bus.$emit('showError');
        return false;
      }
      this.$bus.$emit('loading');
      this.$bus.$emit('showSuccess');
      return true;
    },

    getStatusId() {
      if (this.isProducedState) {
        return this.glassPoStatusIdShipped;
      }
      if (this.isShippedState) {
        return this.glassPoStatusIdReceived;
      }
      if (this.isReceivedState || this.isRepackageState) {
        return this.glassPoStatusIdShippedToSite;
      }
      if (this.isShippedToSiteState) {
        return this.glassPoStatusIdReceivedOnSite;
      }
      return null;
    },

    getUndoStatusId() {
      if (this.isReceivedState) {
        return this.glassPoStatusIdShipped;
      }
      if (this.isShippedState) {
        return this.glassPoStatusIdProduced;
      }
      if (this.isShippedToSiteState && this.item.type_id === this.typeIdRearrange) {
        return this.glassPoStatusIdRepackage;
      }
      if (this.isShippedToSiteState) {
        return this.glassPoStatusIdReceived;
      }
      if (this.isRecevedToSiteState) {
        return this.glassPoStatusIdShippedToSite;
      }
      return null;
    },

    setFormState(id = null, formState = null) {
      this.isProducedState = false;
      this.isShippedState = false;
      this.isReceivedState = false;
      this.isShippedToSiteState = false;
      this.isRecevedToSiteState = false;
      this.isRepackageState = false;

      if (id && formState === this.glassPoStatusIdProduced) {
        this.isProducedState = true;
      } else if (id && formState === this.glassPoStatusIdShipped) {
        this.isShippedState = true;
      } else if (id && formState === this.glassPoStatusIdReceived) {
        this.isReceivedState = true;
      } else if (id && formState === this.glassPoStatusIdShippedToSite) {
        this.isShippedToSiteState = true;
      } else if (id && formState === this.glassPoStatusIdReceivedOnSite) {
        this.isRecevedToSiteState = true;
      } else if (id && formState === this.glassPoStatusIdRepackage) {
        this.isRepackageState = true;
      }
    },

    async addWipPanel() {
      this.$bus.$emit('loading');
      if (!this.wipPanelQr) {
        this.$bus.$emit('loading');
        this.$bus.$emit('showError', 'Qr code not recognized');
        this.wipPanelQr = null;
        return;
      }
      const submitModel = {
        filters: {
          id: this.wipPanelQr,
          is_pack_slip_null: 1,
          is_all: 1,
        },
      };
      const res = await this.$api.wipPanel.read(submitModel);
      const cancelCode = 3001;
      if (res === cancelCode) return;
      if (!res || !res.data || res.data.length === 0) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Panel not found or already produced');
        this.wipPanelQr = null;
        return;
      }

      //if 4800 workflow is enabled give an error when the panel has class 4800
      //if 6000 workflow is enabled give an error when the panel has class 6000
      const wipPanel = res.data[0];
      const wipPanelClass = wipPanel.class ? wipPanel.class.name : '';
      if (this.customPanelWorkflow4800 && wipPanelClass.includes('4800')) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Panel with class 4800 cannot be added to packing slip while 4800 Custom Panel Workflow is enabled');
        this.wipPanelQr = null;
        return;
      }

      if (this.customPanelWorkflow6000 && wipPanelClass.includes('6000')) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Panel with class 6000 cannot be added to packing slip while 6000 Custom Panel Workflow is enabled');
        this.wipPanelQr = null;
        return;
      }

      if (res.data[0].status_id === this.glassPoStatusIdToBeIssued || res.data[0].status_id === this.glassPoStatusIdIssued) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Panel needs to be cut before it can be added to a packing slip');
        this.wipPanelQr = null;
        return;
      }
      if (this.isScanned(res.data[0])) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Panel has already been scanned');
        this.wipPanelQr = null;
        return;
      }
      if (this.item.type_id === this.typeIdRearrange && !res.data[0].packing_slip) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Panel is not under a packing slip and cannot be rearranged');
        this.wipPanelQr = null;
        return;
      }
      // if (res.data[0].status_id === this.glassPoStatusIdShipped || res.data[0].status_id === this.glassPoStatusIdReceived || res.data[0].status_id === this.glassPoStatusIdShippedToSite || res.data[0].status_id === this.glassPoStatusIdReceivedOnSite) {
      //   this.$bus.$emit('loading-stop');
      //   this.$bus.$emit('showError', 'Panel has already been shipped or received and cannot be added to a packing slip');
      //   this.wipPanelQr = null;
      //   return;
      // }
      if (this.item.type_id !== this.typeIdRearrange && res.data[0].packing_slip) {
        this.$bus.$emit('loading-stop');
        const confirm = await this.$refs.confirmForm.open({
          title: `This panel is under ${res.data[0].packing_slip} slip - Would you like to move it?`,
        });
        if (!confirm) {
          this.wipPanelQr = null;
          return;
        }
        const resDelete = this.$api.wipPanelPackingSlipItem.delete(`${res.data[0].packing_slip}/${res.data[0].id}`);
        if (!resDelete) {
          this.$bus.$emit('showError');
          this.wipPanelQr = null;
          return;
        }
      }

      this.item.wip_panel_packing_slip_items.push({ wip_panel: res.data[0], key: res.data[0].id });
      this.$bus.$emit('loading-stop');
      this.$bus.$emit('showSuccess');
      this.wipPanelQr = null;
    },

    isScanned(item) {
      const index = this.item.wip_panel_packing_slip_items.findIndex((x) => x.wip_panel.id === item.id);
      return index >= 0;
    },

    async removeWIPPanelItem(item) {
      const confirm = await this.$refs.confirmForm.open({
        title: 'Are you sure that you want to remove this record?',
      });
      if (!confirm) return;
      const itemIndex = this.item.wip_panel_packing_slip_items.findIndex((x) => x.wip_panel.id === item.wip_panel.id);
      if (itemIndex >= 0) {
        this.item.wip_panel_packing_slip_items.splice(itemIndex, 1);
      }
    },

    convertToFraction(decimal) {
      // check if  a decimal number has numbers after the decimal point
      const decimalString = decimal.toString();
      const decimalPointIndex = decimalString.indexOf('.');

      if (decimalPointIndex === -1) {
        return decimal;
      }
      //

      const fractions = {
        0.0625: '1/16',
        0.125: '1/8',
        0.1875: '3/16',
        0.25: '1/4',
        0.3125: '5/16',
        0.375: '3/8',
        0.4375: '7/16',
        0.5: '1/2',
        0.5625: '9/16',
        0.625: '5/8',
        0.6875: '11/16',
        0.75: '3/4',
        0.8125: '13/16',
        0.875: '7/8',
        0.9375: '15/16',
      };

      // If the decimal is an exact match to any fraction, return the fraction directly
      if (decimal in fractions) {
        return fractions[decimal];
      }

      const wholeNumber = Math.floor(decimal);
      // eslint-disable-next-line no-param-reassign
      decimal -= wholeNumber; // Remove the whole number part

      let closestFraction = Object.keys(fractions)[0];

      // eslint-disable-next-line no-restricted-syntax
      for (const fraction of Object.keys(fractions)) {
        if (Math.abs(decimal - fraction) < Math.abs(decimal - closestFraction)) {
          closestFraction = fraction;
        }
      }

      if (wholeNumber > 0) {
        return `${wholeNumber} - ${fractions[closestFraction]}"`;
      }
      return fractions[closestFraction];
    },

    convertDateFormat(inputDate) {
      // Parse the input date
      const date = new Date(inputDate);

      // Format the date as "YYYY-MM-DD h:mm a" (e.g., 2023-10-24 9:25 PM)
      const formattedDate = date.toLocaleString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      });

      return formattedDate;
    },

    qrCodeValueChange() {
      if (!this.wipPanelQr) return;
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(() => {
        this.addWipPanel();
      }, 700);
    },

    headlineText() {
      if (this.isProducedState) {
        return 'Ship';
      }
      if (this.isShippedState) {
        return 'Receive';
      }
      if (this.isReceivedState || this.isRepackageState) {
        return 'Ship To Site';
      }
      if (this.isShippedToSiteState) {
        return 'Receive On Site';
      }
      if (this.item.id && this.item.type_id === this.typeIdRearrange) {
        return 'Update Rearranged';
      }
      if (this.item.id) {
        return 'Update';
      }
      if (this.item.type_id === this.typeIdRearrange) {
        return 'Rearrange';
      }
      return 'Create';
    },

    submitBtnText() {
      if (this.isProducedState) {
        return 'Ship';
      }
      if (this.isShippedState) {
        return 'Receive';
      }
      if (this.isReceivedState || this.isRepackageState) {
        return 'Ship To Site';
      }
      if (this.isShippedToSiteState) {
        return 'Receive On Site';
      }
      if (this.item.id) {
        return 'Update';
      }
      return 'Submit';
    },

    undoBtnText() {
      if (this.isRepackageState) {
        return '';
      }
      if (this.isReceivedState) {
        return 'Undo Receive';
      }
      if (this.isShippedState) {
        return 'Undo Ship';
      }
      if (this.isShippedToSiteState) {
        return 'Undo Ship To Site';
      }
      if (this.isRecevedToSiteState) {
        return 'Undo Receive On Site';
      }
      return '';
    },

    isRemoveBtn() {
      return !(this.isProducedState || this.isShippedState || this.isReceivedState) && this.item.status_id !== this.glassPoStatusIdReceived && this.item.type_id !== this.typeIdRearrange;
    },

  },
};
</script>
